import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Button from '../ui/Button';
import site from '../../data/site.json';
import './Navbar.css';

const LINKS = [
  { label: 'Work', target: 'work' },
  { label: 'Services', target: 'services' },
  { label: 'Creators', target: 'creators' },
  { label: 'Process', target: 'process' },
  { label: 'FAQ', target: 'faq' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const goToSection = (id) => {
    setMobileOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      // wait for home to render
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner tra-container">
        <Link to="/" className="nav__brand" onClick={() => setMobileOpen(false)}>
          <img src={process.env.PUBLIC_URL + site.logo} alt={site.name} />
        </Link>

        <nav className="nav__links" aria-label="Primary">
          {LINKS.map((l) => (
            <button key={l.target} onClick={() => goToSection(l.target)}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="nav__cta">
          <Button onClick={() => goToSection('contact')} variant="primary" arrow>
            Work With Us
          </Button>
        </div>

        <button
          className={`nav__toggle ${mobileOpen ? 'is-open' : ''}`}
          onClick={() => setMobileOpen((o) => !o)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      <div className={`nav__mobile ${mobileOpen ? 'is-open' : ''}`}>
        {LINKS.map((l) => (
          <button key={l.target} onClick={() => goToSection(l.target)}>
            {l.label}
          </button>
        ))}
        <Button onClick={() => goToSection('contact')} variant="primary" size="lg" arrow>
          Work With Us
        </Button>
      </div>
    </header>
  );
};

export default Navbar;
